// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={144}
      height={70}
      viewBox="0 0 144 70"
      {...props}
    >
      <g fill="none">
        <path
          fill="#E22026"
          d="M71.5 0c-4.177 4.572-5.507 7.611-5.507 11.153 0 4.862 4.641 9.861 5.507 18.3.865-8.439 5.507-13.438 5.507-18.3 0-3.542-1.33-6.581-5.507-11.153ZM61.45 19.546c-2.68 0-5.45 2.24-5.45 4.868 0 4.65 4.304 5.889 6.504 3.967-.755-.024-1.227-.68-1.227-1.468 0-.886.958-1.7 2.23-1.7 2.29 0 3.339 2.113 3.523 3.73.157 1.363-.379 3.276-1.988 4.057 3.437-.043 4.373-3.262 4.263-5.304-.142-2.588-2.562-8.15-7.856-8.15Zm20.106 0c-5.294 0-7.716 5.562-7.856 8.15-.11 2.042.825 5.261 4.264 5.304-1.61-.78-2.147-2.694-1.989-4.058.185-1.616 1.232-3.729 3.524-3.729 1.27 0 2.23.814 2.23 1.7 0 .788-.477 1.444-1.233 1.468 2.2 1.922 6.504.683 6.504-3.967 0-2.629-2.764-4.868-5.444-4.868Z"
        />
        <path
          fill="#231F20"
          d="M48.473 42c-4.822 0-8.789 2.842-8.789 7.28 0 7.473 14.173 7.641 14.173 13.276 0 3.353-4.103 4.026-6.97 3.798-2.557-.204-4.795-1.026-7.203-2.572v3.877c2.417 1.582 4.693 2.17 7.74 2.323 4.479.225 10.3-1.647 10.3-7.296 0-8.673-14.059-8.692-14.059-13.926 0-2.32 2.454-3.55 5.253-3.55 1.855 0 4.535.384 6.736 2.244l-.011-3.668C53.665 42.667 51.588 42 48.473 42Zm26.95.006c-8.915 0-14.761 6.435-14.761 13.988 0 7.394 5.686 13.988 14.68 13.988 4.401 0 7.965-1.478 10.5-3.815l-2.093-3.436c-1.926 2.268-4.874 3.657-8.327 3.657-6.132 0-10.688-4.439-10.688-10.394 0-5.994 4.556-10.388 10.688-10.388 3.358 0 6.24 1.3 8.167 3.453l2.065-3.442c-2.532-2.234-6.023-3.611-10.232-3.611Zm26.702 0c-8.914 0-14.76 6.435-14.76 13.988 0 7.395 5.688 13.988 14.68 13.988 9.318 0 14.887-6.633 14.887-13.988 0-7.593-5.731-13.988-14.807-13.988ZM0 42.367v27.26h3.907V57.751h16.38v11.874H24.2V42.367h-3.913v11.87H3.907v-11.87H0Zm30.36 0v27.26h3.912v-27.26h-3.913Zm86.092 0 11.014 13.147-11.858 14.112h4.797l9.479-11.275 9.36 11.275H144l-11.738-14.112 10.974-13.147h-4.763l-8.589 10.388-8.63-10.388h-4.802Zm-14.327 3.239c6.171 0 10.734 4.394 10.734 10.388 0 5.956-4.563 10.394-10.734 10.394-6.13 0-10.682-4.438-10.682-10.394 0-5.994 4.552-10.388 10.682-10.388Z"
        />
      </g>
    </svg>
  );
};

const HiscoxIcon = Icon;
export default HiscoxIcon;
